<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <card class="strpied-tabled-with-hover" body-classes=" table-responsive">
            <template slot="header">
              <h4 class="card-title"><i class="icon-svg icon-file-text"></i>{{$t('Documentos')}}</h4>
            </template>
            <file-explorer ref="fileExplorer" :indexFolder="documents" :root="endpoint" v-if="documents"/>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import FileExplorer from "@/components/FileExplorer";
import { apiCallList } from '../../mixins'

export default {
    mixins: [apiCallList],
    watch: {
      $route(to, from) {
            // The explorer strips a stale ?path= with router.replace when the deep
            // link points at a folder that is not there. That is the same route
            // record, so this watcher fires for it: refetching there reloads a listing
            // that is already on screen and, worse, writes an undefined selectFolder
            // into the explorer (this route carries no :id). Only a change of folder
            // is a reason to fetch again.
            if (to.path === from.path) return;

            this.endpoint = "documents?where-parent_id="+ (this.id ? this.id : 0),
            this.updateDocument = true;
            this.fetch();
          if(this.id){
            this.onReadDocuments();
          }      
        }
    },
    data(){
        return {
            endpoint : "documents?where-parent_id="+(this.id ? this.id : 0),
            itemSelected : {},
            options : true,
            documents : null,
            updateDocument : false
        }
    },
    components : {
        FileExplorer
    },
    props :{
      id : String
    },
    created(){
      if(this.id)
        this.onReadDocuments();
    },
    methods : {
        loadItems(){
            this.documents = this.data;
            if(this.updateDocument){
              this.$refs.fileExplorer.selectFolder = this.id;
              this.$refs.fileExplorer.updateDocuments(this.documents)
            }
        },
        onReadDocuments(){
          this.$axios("/read_notification/"+this.id)
            .then(() => {
                this.$store.dispatch('login/documentNotifications');
            })
              .catch (() => {
                //this.$store.dispatch ('isLoadingOff');
              });
        }
    }
}
</script>